import React, { useEffect } from "react";
import { Toast } from "@themesberg/react-bootstrap";
import "./toastAnimations.css"; // Import the CSS file

export const ToastAlert = ({ show, onClose, message, variant = "info" }) => {
  // Optional: play sound when toast appears
  useEffect(() => {
    if (show) {
      const audio = new Audio("/sounds/notify.mp3"); // put file in public/sounds/
      audio.play().catch(() => {}); // avoid blocking errors
    }
  }, [show]);

  return (
    <div
      style={{
        position: "fixed",
        top: "1rem",
        right: "1rem",
        zIndex: 9999,
        minWidth: "250px",
      }}
    >
      <Toast
        className={`toast-animate toast-${variant}`}
        show={show}
        onClose={onClose}
        autohide
        delay={4000}
      >
        <Toast.Header>
          <strong className="me-auto">
            {variant === "danger" ? "Error" : "Notice"}
          </strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </div>
  );
};
